export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED'

const codeMessage: { [index: string]: string } = {
  AUTHENTICATION_FAILED: 'Authentication failed, The User not to login or the token expired',
  USER_ALREADY_EXISTS: 'The username/email is already in use. sign up failed',
  USER_NOT_EXIST: 'The username/email is not exist. sign in failed',
  USER_NEED_SIGN_TERMS: 'The user is created by org manager. the user need to sign terms and change password',
  PASSWORD_INCORRECT: 'The username/email and password not match when login.',
  PASSWORD_EXPIRED: 'The password is expired.',
  // eslint-disable-next-line quotes
  UNDELETABLE: `The source can't be deleted, It is referenced by other resources`,
  ENTITY_NOT_FOUND: 'The source not found',
  INVITATION_EXPIRED: '', // not show the error message
  LEAVE_ORG_FAILED: 'Leave organization action failed.',
  CODE_ALREADY_EXISTS: 'The Code already exists, please use a new one.',
  UPDATE_START_DATE_FAILED: 'Update task start date failed.',
  UPDATE_END_DATE_FAILED: 'Update task end date failed.'
}

export default codeMessage
